module.exports = __webpack_public_path__ + "11d5e87044640e6fa5e3d186a19e7473.png";


//////////////////
// WEBPACK FOOTER
// ./public/bg6.png
// module id = 72
// module chunks = 0